/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import Flex from './Flex';

export default function Row(props) {
  return <Flex wrap="wrap" sx={{ marginX: '-columnGap' }} {...props} />;
}
